import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import InternetPopup from './components/inc/InternetPopup';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
  <InternetPopup />
  <React.StrictMode>
    <App />
  </React.StrictMode>
  </>
);
reportWebVitals();
